module.exports = __webpack_public_path__ + "media/images/header-bg-01-824149bd932e42070f3d0e9989ec5d16.png";